import type { FeeStructure as GQLItem } from '../../../generated/internal.graphql';
import { take } from '../../../util/takePayload';

export type FeeStructure = {
  id: number;
  name: string;
};

export const fromGql = (item: GQLItem): FeeStructure =>
  take<FeeStructure>(item, 'id', 'name');
